<template>
  <div :class="{'ui-switcher-container': true, 'disabled': disabled}">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'UiSwitcher',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Number]
    }
  },

  created () {
    this.$on('active-item', this.setActiveItem)
  },

  beforeDestroy () {
    this.$off('active-item', this.setActiveItem)
  },

  methods: {
    setActiveItem (component) {
      this.$emit('input', component?.id)
    }
  }
}
</script>

<style scoped lang="scss">
.ui-switcher-container {
  @include pretty-scrollbar-s;
  display: flex;
  overflow: auto;
}

.ui-switcher-item {
  border: initial;
  background-color: $light-01;
}

.ui-switcher-container .ui-switcher-item:first-child {
  border-right: initial;
  border-radius: 5px 0 0 5px;
}

.ui-switcher-container .ui-switcher-item:last-child {
  border-right: solid 1px $gray-01;
  border-radius: 0 5px 5px 0;
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
